<template>
  <div>
    <div
      v-if="project != null && project.company"
      style="margin-bottom: 16px; margin-top: 8px"
    >
      <v-text-field v-model="instance.company" label="Entreprise" />
      <v-text-field
        v-model="instance.companyContactName"
        label="Nom du contact"
      />
      <v-text-field v-model="instance.companyMail" label="Email du contact" />
      <v-text-field
        v-model="instance.companyPhone"
        label="Téléphone du contact"
      />
    </div>

    <v-select
      v-model="instance.contractType"
      :items="contractTypes"
      label="Type de contrat"
      data-vv-name="contractType"
      :error-messages="errors.collect('contractType')"
    />
    <v-combobox
      :items="companiesNames"
      :search-input.sync="instance.company"
      label="Nom de l'entreprise"
      :error-messages="errors.collect('company')"
      :hide-no-data="true"
      :return-masked-value="true"
      data-vv-name="company"
      v-if="project == null && !useReferer"
      class="hide-arrow"
    />
    <vuetify-google-autocomplete
      id="map3"
      v-model="instance.addressWork"
      append-icon="map"
      label="Adresse de travail"
      data-vv-name="addressWork"
      :error-messages="errors.collect('addressWork')"
      @placechanged="
        data => {
          instance.addressWorkObject = data;
        }
      "
    />
  </div>
</template>

<script>
import { CONTRACT_TYPES } from "../../../../webapp-commons/data";
import { fetchHil2 } from "../../utils";

export default {
  name: "ProjectCompany",
  props: ["project", "useReferer"],
  data() {
    return {
      instance: {
        company: "",
        companyContactName: "",
        companyContactMail: "",
        companyContactPhone: "",
        companyId: null,
        companyMail: "",
        companyPhone: "",
        contractType: "",
        addressWork: "",
        addressWorkObject: null
      },
      companyAutocomplete: []
    };
  },
  mounted() {
    this.syncWithProject();
    this.fetchCompanyAutocomplete();
  },
  computed: {
    contractTypes() {
      return CONTRACT_TYPES;
    },
    companiesNames() {
      return this.companyAutocomplete.map(({ name }) => name);
    }
  },
  methods: {
    syncWithProject() {
      if (this.project != null) {
        const {
          company,
          companyContactName,
          companyContactMail,
          companyContactPhone,
          addressWork,
          addressWorkObject,
          companyMail,
          companyPhone,
          contractType
        } = this.project;
        this.instance = {
          company,
          companyContactName,
          companyContactMail,
          companyContactPhone,
          companyMail,
          addressWork,
          addressWorkObject,
          companyPhone,
          contractType
        };
      }
    },
    async fetchCompanyAutocomplete() {
      this.companyAutocomplete = await fetchHil2(
        "get",
        "/prospects/_autocomplete?type=entreprise"
      );
    },
    async send() {
      await this.$validator.validate();
      this.$emit("input", { ...this.instance });
    }
  },
  watch: {
    instance: {
      deep: true,
      async handler() {
        const cpn = this.instance.company;
        if (cpn) {
          const [company] = this.companyAutocomplete.filter(
            ({ name }) => name.toLowerCase() === cpn.toLowerCase()
          );
          this.instance.companyId = company != null ? company._id : null;
        }
        return this.send();
      }
    },
    project: {
      deep: true,
      handler() {
        this.syncWithProject();
      }
    }
  }
};
</script>

<style>
.hide-arrow .v-input__icon--append {
  display: none !important;
}
</style>
